import { Dialog } from '@headlessui/react';
import {
  XIcon,
  PlusIcon,
  TruckIcon,
  UsersIcon,
  VideoCameraIcon,
  LinkIcon
} from '@heroicons/react/solid';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Logo from '../assets/image/vinsyt-logo.svg';
import Modal from './Modal';
import { userLogout } from '../helpers/app';
import withStateDispatch from '../redux/withStateDispatch';
import { getRooftop, getRooftopConfig } from '../utils/firebase';
import Icon from '../assets/image';

const Drawer = ({ user, rooftop, setRooftop, isOpen, setIsOpen }) => {
  const { pathname } = useLocation();
  const [modal, setModal] = useState(false);

  useEffect(() => {
    async function myApi() {
      const rooftopRes = await getRooftop();
      const rooftopConfig = await getRooftopConfig();

      setRooftop({
        ...rooftopRes,
        config: rooftopConfig
      });
    }
    myApi();
  }, []);

  const menuItems = [
    {
      label: 'Inventory',
      to: '/inventory',
      icon: <TruckIcon width={20} />,
      match: '/inventory',
      external: false,
      key: 'inventory'
    },
    {
      label: 'Create Referral',
      to: '/referrals',
      icon: <UsersIcon width={20} />,
      match: '/referrals',
      external: false,
      key: 'referrals'
    },
    {
      label: 'Video Testimonials',
      to: '/owners',
      icon: <VideoCameraIcon width={20} />,
      match: '/owners',
      external: false,
      key: 'owners'
    },
    {
      label: 'Add Inventory',
      to: '/add-vehicle',
      icon: <PlusIcon width={20} />,
      match: '/add-vehicle',
      external: false,
      key: 'add-vehicle'
    },
    {
      label: 'Scan QR',
      to: '/scan-qr',
      icon: <Icon name="QrIcon" size={20} color={pathname === '/scan-qr' ? 'blue' : ''} />,
      match: '/scan-qr',
      external: false,
      key: 'scan-qr'
    },
    {
      label: 'Redemption History',
      to: '/redemption-history',
      icon: (
        <Icon
          name="QrHistoryIcon"
          size={20}
          color={pathname === '/redemption-history' ? 'blue' : ''}
        />
      ),
      match: '/redemption-history',
      external: false,
      key: 'redemption-history'
    },
    {
      label: 'Training Portal',
      to: 'https://revferral.atlassian.net/wiki/spaces/TRAIN/pages/2061533191/Understanding+vinsyt', // <-- update this if needed
      icon: <LinkIcon width={20} />,
      external: true,
      key: 'training-portal'
    }
  ];

  let filteredMenuItems = menuItems;
  // const rewardsActive = rooftop?.config?.rewards?.status === true;
  const rewardsActive = true;
  if (!user?.role?.includes('sales')) {
    filteredMenuItems = menuItems
      .filter((item) => {
        if (['scan-qr', 'redemption-history'].includes(item.key)) {
          return rewardsActive;
        }
        return item.key === 'training-portal';
      })
      .map((item) =>
        item.key === 'training-portal'
          ? {
              ...item,
              to: 'https://revferral.atlassian.net/wiki/spaces/TRAIN/pages/2061533191/Understanding+vinsyt'
            }
          : item
      );
  } else {
    // For sales, still hide scan-qr and redemption-history if rewards is not active
    filteredMenuItems = menuItems.filter((item) => {
      if (['scan-qr', 'redemption-history'].includes(item.key)) {
        return rewardsActive;
      }
      return true;
    });
  }

  return (
    <Dialog
      unmount={false}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="max-w-screen-md mx-auto fixed z-30 inset-0 overflow-y-auto">
      <div className="flex w-3/4 h-screen">
        <Dialog.Overlay
          className="z-40 fixed inset-0 bg-black bg-opacity-30"
          onClick={() => setIsOpen(!isOpen)}
        />
        <div
          className={`z-50 flex flex-col justify-between bg-white w-full
                       max-w-sm overflow-hidden text-left align-middle
                       shadow-xl`}>
          <div className="flex items-center justify-between p-6">
            <Dialog.Title className="">
              <img src={Logo} className="w-24" alt="logo" />
            </Dialog.Title>
            <Dialog.Description onClick={() => setIsOpen(!isOpen)}>
              <XIcon width={20} />
            </Dialog.Description>
          </div>
          <hr />
          <div className="flex flex-col grow px-6 mt-6">
            {filteredMenuItems.map((item) =>
              item.external ? (
                <a
                  key={item.label}
                  href={item.to}
                  target="_blank"
                  rel="noreferrer"
                  className="flex gap-2 py-3 text-lg tracking-wide">
                  {item.icon} {item.label}
                </a>
              ) : (
                <Link
                  key={item.label}
                  to={item.to}
                  className={`flex items-center gap-2 py-3 text-lg tracking-wide ${
                    pathname === item.match ? 'text-[#5046E4] font-bold' : ''
                  }`}>
                  {item.icon} {item.label}
                </Link>
              )
            )}
          </div>
          <hr />
          <div className="px-6 py-3">
            <div className="flex items-center gap-2">
              <img className="w-9 h-9 object-contain" src={rooftop?.logo} alt="Dealer Logo" />
              <p className="font-bold text-md">{rooftop?.name}</p>
            </div>
          </div>
          {/* <hr />
          <div className="flex gap-2 px-6 py-3">
            <img className="w-9 h-9 rounded-full" src={user?.avatar} alt="user_profile" />
            <div>
              <p className="font-bold text-md">
                {user?.name?.first} {user?.name?.last}
              </p>
              <p className="text-sm">{user?.email}</p>
            </div>
          </div> */}
          <div className="">
            <button
              type="button"
              className="flex w-full gap-2 items-center justify-start text-white font-semibold bg-[#5046E4] px-6 py-4"
              onClick={() => setModal(true)}>
              <Icon name="LogoutIcon" size={17} color="white" />
              Logout
            </button>
          </div>
        </div>
      </div>
      <Modal
        modal={modal}
        customPadding
        icon={<Icon name="LogoutIcon" size={27} color="#5046E4" />}
        content="Are you sure you want to log out of this user?"
        positiveButton="Yes"
        negativeButton="No, cancel"
        onPositiveClick={() => userLogout()}
        onNegativeClick={() => setModal(false)}
      />
    </Dialog>
  );
};

export default withStateDispatch(Drawer);
